import React, { useState, useContext } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { fetchLogin } from 'store/utilisateur/courantActions';

import { UtilisateurCourantContext } from 'context/UtilisateurCourantContext';

import { useNavigate } from 'react-router-dom'

import LoginForm from './LoginForm';

import { Domaine } from 'constants.js';


const LoginFormContainer = ({ isConnecting, fetchLogin, from }) => {

    const utilisateurCourantContext = useContext(UtilisateurCourantContext);

    const navigate = useNavigate();

    let [username, setUsername] = useState('');
    let [password, setPassword] = useState('');
    let [domaine, setDomaine] = useState(Domaine.Foussier);

    const handleChange = (event) => {

        if (event.target.name === 'username') {
            let value = event.target.value;

            // Si l'utilisateur tape @ et que c'est le premier @, proposer @foussier.fr
            if (value.endsWith('@') && value.indexOf('@') === value.length - 1) {
                value = value + 'foussier.fr';
            }

            setUsername(value);
        } else if (event.target.name === 'password') {
            setPassword(event.target.value);
        } else if (event.target.name === 'domaine') {
            setDomaine(event.target.value);
        }
    };

    const handleSubmit = async () => {

        const utilisateur = await fetchLogin(username, password, domaine);

        if (utilisateur) {

            // Insertion dans le contexte
            utilisateurCourantContext.setUtilisateur(utilisateur);                

            // On est redirigé vers la page demandée
            navigate(from.pathname);
        }
        else 
        {            
            // Suppression dans le contexte
            utilisateurCourantContext.setUtilisateur(null);

            // Reset du formulaire
            setPassword('');
        }

    };

    return (
        <LoginForm
            isLoading={isConnecting}
            onChange={handleChange}
            onSubmit={handleSubmit}
            username={username}
            password={password}
            domaine={domaine}
        />);
};


LoginFormContainer.propTypes = {
    from: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    isConnecting: state.utilisateur.courant.isConnecting
});


const mapDispatchToProps = {
    fetchLogin,
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginFormContainer);